/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { challengeV6Schema } from '../getPublicChallengeBySlugV6/get-public-challenge-by-slug-v6-response';
import { publicChallengeClipItemV2Schema } from '../listPublicChallengeClipsBySlugV2/list-public-challenge-clips-by-slug-v2-response';
import { publicChallengeTranslationItemSchema } from '../listPublicChallengeTranslationsBySlugV1/list-public-challenge-translations-by-slug-v1-response';

export const challengePageBundleV1Schema = z.object({
  challenge: challengeV6Schema,
  clips: z.array(publicChallengeClipItemV2Schema),
  translations: z.array(publicChallengeTranslationItemSchema),
});

export type IChallengePageBundleV1 = z.infer<typeof challengePageBundleV1Schema>;

export const getChallengePageBundleV1ResponseSchema = createApiResponseSchema(
  challengePageBundleV1Schema,
) as z.ZodSchema<IAPI<IChallengePageBundleV1>>;

export type IGetChallengePageBundleV1Response = IAPI<IChallengePageBundleV1>;
